<template>
    <CModal title="Cập nhật chi tiết chính sách" :show.sync="isShowPopup">
        <CRow class="content-fade-in">
          <CCol md="12">
                <CForm class="form-basic">
                  <CRow>
                    <CCol sm="12" md="12" xl="12">
                      <BaseInput
                        :options="codeInput.options"
                        :data="codeInput.data"
                      />
                      <BaseInput
                        :options="nameInput.options"
                        :data="nameInput.data"
                      />
                      <BaseSelect
                        :options="isActiveSelect.options"
                        :data="isActiveSelect.data"
                        ref="isActive"
                      >
                      </BaseSelect>
                    </CCol>
                  </CRow>
                  <BaseLoading :loading="loading.value"></BaseLoading>
                </CForm>
          </CCol>
        </CRow>

        <template v-slot:footer>
            <div slot="footer">

                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="isShowPopup = false"
                    ><i class="fa fa-reply"></i> Hủy bỏ
                </button>&nbsp;

                <button
                    type="button"
                    class="btn btn-primary"
                    @click="submitData()"
                    >
                    <i class="fa fa-refresh"></i> Cập nhật
                </button
                >
            
            </div>
        </template>
    </CModal>
</template>
<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";

export default {
  props: ["actionTypeMapping"],
  components: {BaseInput, BaseSelect, BaseLoading},
  data() {
    var that = this;
    return {
      isShowPopup: false,
      actionTypeKey: '',
      policyId: '',

      loading: {value: false},
      idField: {
        data: {
          model: -1,
          name: "id"
        }
      },
      codeInput: {
        options: {
          label: "Mã chi tiết chính sách *",
          placeholder: "Mã chi tiết chính sách",
          type: "text",
          maxlength: 100
        },
        data: {
          name: "code",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.codeInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Mã chi tiết chính sách không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      nameInput: {
        options: {
          label: "Tên chi tiết chính sách *",
          placeholder: "Tên chi tiết chính sách",
          type: "text",
          maxlength: 500
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Tên chi tiết chính sách không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      isActiveSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "active",
          items: [
            {key: "true", value: "Hoạt động"},
            {key: "false", value: "Không hoạt động"},
          ],
          model: 'true'
        }
      },
      policyId: {
        data: {
          name: "policyId",
          model: that.$route.params.id
        }
        
      },
      
    };
    
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    }
  },
  methods: {
    getData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/policy-detail/findById",
        dataSubmit: function () {
          return {id: that.idField.data.model}
        },
        isJsonContentType: false,
        successCallback: function (response) {
          let dataRes = response.data.data;
          dataRes.active = dataRes.active+"";
          that.dataCache = that.$helper.setupDataResponse(that.$data, dataRes);
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitData: function () {
      let that = this;
      var actionType = this.actionType;
      var _successCallback = actionType.successCallback;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/policy-detail/updatePolicyDetail",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          that.isShowPopup = false;
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else if(_successCallback){
            _successCallback(response.data);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.isShowPopup = false;
        }
      });
    },
    setCurrAction: function(key) {
      this.actionTypeKey = key;
    },

    setIdField: function(id) {
      this.idField.data.model = id;
    }
  },
  created() {
    
  },
  mounted() {
    // this.getData();
  },
  updated() {

  },
  computed: {
    actionType: function() {
      return this.actionTypeMapping.get(this.actionTypeKey);
    }
  },
  watch: {
   actionTypeKey: function(newValue) {
     if(newValue) {
       this.isShowPopup = true;
     }
   },
   isShowPopup: function(newValue) {
     if(!newValue) {
       this.actionTypeKey = null;
     }
   }
  }
};
</script>
<style scoped></style>
